import { render, staticRenderFns } from "./AdminFinalExamAdminListIndex.vue?vue&type=template&id=6f887770"
import script from "./AdminFinalExamAdminListIndex.vue?vue&type=script&lang=js"
export * from "./AdminFinalExamAdminListIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports